import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');

const app = (
    <BrowserRouter>
        <App/>
    </BrowserRouter>
);

// react-snap prerenders static HTML into #root at build time.
// Hydrate that markup when it exists; otherwise render fresh.
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
} else {
    createRoot(rootElement).render(app);
}
